<template>
  <div class="input-group">
    <label>{{ label }}</label>
    <select :value="selectedValue" @change="handleChange">
      <option disabled value="">Seleccione una opción</option>
      <option v-for="(name, code) in espacios" :key="code" :value="code">{{ name }}</option>
    </select>
    <input
      v-if="selectedValue === '15'"
      type="text"
      placeholder="Especifique el espacio"
      v-model="otroInput"
      @input="emitirOtro"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    label: String
  },
  data() {
    return {
      espacios: {
        "1": "Palco de Honor",
        "2": "Sala de Prensa y Zona Mixta",
        "3": "Espacio Castellana",
        "4": "Sala Flash VIP",
        "5": "Zona Prensa Nivel 8",
        "6": "Losa/ Terreno de Juego",
        "7": "Espacios en zonas de recorrido del TOUR",
        "8": "Banda/ Banquillos",
        "9": "Ciudad Deportiva Campos",
        "10": "Ciudad Deportiva Salas...",
        "11": "Zona VIP N3 FS",
        "12": "Zona VIP N3 LO",
        "13": "Zona VIP N3 LE",
        "14": "AFFINITY CLUB",
        "15": "OTROS"
      },
      selectedValue: this.value,
      otroInput: ''
    };
  },
  methods: {
    handleChange(event) {
      this.selectedValue = event.target.value
      if (this.selectedValue === '15') {
        this.emitirOtro()
      } else {
        this.$emit('input', this.selectedValue)
      }
    },
    emitirOtro() {
      this.$emit('input', this.otroInput || 'otros')
    }
  },
  watch: {
    otroInput() {
      this.emitirOtro()
    }
  }
}
</script>